import { BrandProduct } from './brand-product';

export class Brand {
    brandId: number;
    brandName: string;
    processed: boolean;
    createdDate?: Date;
    parentId?: number;
    productCount: number;
    catalogBrand?: string;
    products: BrandProduct[] = [];

    constructor(options?: Partial<Brand>) {
        Object.assign(this, options);
    }
}
